import { useDrop } from 'react-dnd'

const DragTarget = ({ accept, onDrop, children }) => {
  const [, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  })

  return (
    <div ref={drop} role="Drop">
      {children}
    </div>
  )
}

export default DragTarget
